import color from "../../constants/color";

const style = {
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingRight: 3.5,

  },
  noShadow: {
    mt:2
  },
  modalGrid: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%", 
    mb:1

  },
  gridContiner: {
    alignItems: "center",
 
  },
  inputBoxs: {
    width: {xs:"100%", md: "49%", lg:"31%"},
    ml:1
  },
  inputBoxEnd: {
    textAlign: "end",

  },
  inputTexts: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    mt: 1,
  },
  hoursInput: {
    width: "100%",
    borderRadius: "8px",
    height: "2.5em",
    mt:1,

    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "8.5px 14px",
      borderRadius: "8px",

    },
    "& .css-156w56f-MuiInputBase-root-MuiOutlinedInput-root": {
      borderRadius: "8px",

    },
    ".css-3dzjca-MuiPaper-root-MuiPopover-paper-MuiMenu-paper" : {
      maxWidth: "25%"
    }


  },
  emailTransfer: {
    width: "100%",
    mt:1
  },
  containerRight: {
    // display: {xs: "block", md:"flex"},
    justifyContent: "space-between",
    alignItems: "center",
    px:{xs: 0, md: 3.5},
    width: {xs:"80%", md:"30%"},
    mt:{xs:2,md:0}
  },

  leaveHeading: {
    fontWeight: 600,
    fontSize: "20px",
  },
  reportGrid: {
    px: "15px",
    mt: 2,
    display: {xs: "block", md:"flex"},
    alignItems: "center",
    mb: 2,
    justifyContent: "space-between",
  },

  calenderInput: {
    "& .MuiInputBase-input": {
      padding: "7.5px 14px"
    },
    width: "100%"
  },

  gridContainer: {
    alignItems: "center",
    mt: 2
    // justifyContent: "space-between"


  },
  secondGrid: {
    ml: 2,
    display: "flex",
    textAlign: "end",
    justifyContent: "end"

  },
  dropdowns: {

    fontWeight: 400,
    fontSize: "12px",
    color: color.lightText

  },
  dropDownMenu: {
    fontWeight: 400,
    fontSize: "12px",

  },

  endTime: {
    ml: 2
  },
  radioGrid: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap-reverse",
    mb: 1
  },
  btnGrid: {
    textAlign: "end",
    mx: 1
  },
  btnSection: {
    display: "flex",
    justifyContent: "end",

  },
  labels: {
    fontSize: "14px",
    fontWeight: "500",
    color: color.text,
    my: "10px"
  },

  submitButton: {
    borderRadius: 50,
    mr:1,
    fontSize: "14px",
    fontWeight: "500",
    textTransform: "none",
    backgroundColor: color.primary,
    " & .css-1yt7yx7-MuiLoadingButton-loadingIndicator": {
      position: "unset",
    },
    "& .MuiButton-startIcon": {
      marginRight: "8px",
      marginLeft: "8px",
    },
  },
  submitPdf: {
    borderRadius: 50,
    fontSize: "14px",
    fontWeight: "500",
    textTransform: "none",
    backgroundColor: color.secondary,
    " & .css-1yt7yx7-MuiLoadingButton-loadingIndicator": {
      position: "unset",
    },
    "& .MuiButton-startIcon": {
      marginRight: "8px",
      marginLeft: "8px",
    },
  },
  label: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    my: 1
  },
  reason: {
    borderRadius: "18px",

    width: "100%",
    ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      py: 1
    },
  },
  formGrid: {
    display: "flex"
  },

  dateInput: {
    width: "100%",
    my: 1,


    "& .MuiInputBase-input": {
      padding: "8.5px 14px",
    }
  },

  jobButton: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#28AA4A",
    fontSize: "12px",
    mt: 1,
  },

  inputSection: {
    // display:"flex",
    px: 2,
    alignItems: "center",
    // justifyContent: "space-between",
    mb: 1.5,
    width: "100%"
  },

  inputLabel: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text
  },
  addIcon: {
    p: 1,
    backgroundColor: "#D4EEDB",
    borderRadius: "5px",
    color: color.primary,
    textAlign: "center"
  },
  inputContainer: {
    // width:{xs:"18em",md:"25em",},
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between"
  },
  inputContainerBox: {
    // width:{xs:"18em",md:"25em",},
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 1,
  },
  inputSpace: {
    "& .MuiOutlinedInput-root": {
      padding: "0px 14px"
    }

  },


  modalInput: {
    display: "flex",    // backgroundColor:color.lightGray,
    // borderRadius:"30px",
    
    justifyContent: "center",// Center align on smaller screens
    height: "2.4em",
    fontSize: "14px",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "5.5px 14px",
    },
    "& .MuiOutlinedInput-root": {
      padding: "0"
    },
    width: "100%"
  },
  modalInputReport: {
    display: "flex",    // backgroundColor:color.lightGray,
    // borderRadius:"30px",
    py: "19px",
    justifyContent: "center",// Center align on smaller screens
    // my:"10px",
    height: "2.4em",
    fontSize: "14px",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "14px",
    },
    "& .MuiOutlinedInput-root": {
      padding: "0"
    },
    width: "100%"
  },
  selectGrid: {
    mr: 1,
    backgroundColor:"white"
  },

  uploadSection: {
    px: 2,
    width: { xs: "100%", md: "55%" },

    "& .css-2y07vr": {
      py: "7px"

    }
  },
  leaveInputGrid: {
    display: { xs: "block", md: "flex" },
    alignItems: "center",
    justifyContent: "space-between"

  },
  leaveSheetGrid: {
    display: { xs: "block", md: "flex" },
    ml: { xs: 0, md: 2 },
    mt: { xs: 0, md: 2 },
    height: "fit-content"
  },
  leaveSheet: {
    border: "1px solid rgba(0, 0, 0, 0.23)",
    borderRadius: "5px",
    px: 1,
    mr: 1,
    mb: { xs: 1, md: 0 },
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",

    " & .css-0": {
      display: "flex",

    },
  },
  closeIcon: {
    fontSize: "1rem",
    ml: 2,
  },

  inputBox: {
  },
  inputText: {
    fontSize: "14px",
    fontWeight: "400",
    color: color.text,
  },
  addTaxButton: {
    borderRadius: 40,
    minWidth: "36px",
    width: "36px",
    height: "36px",
    padding: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: "0 0 auto",
  },
  gridbox: {
    backgroundColor: "#ffff",
    m: 2,
    py: 4,
    px: 1,
    // mr: { xs: 3, sm: 3, md: 3, lg: 0 },
    borderRadius: "20px",
    height: "fit-content",
    display: "flex",
    flexWrap: "wrap",
    // justifyContent: "end"

  },
  gridboxss: {
    m: 2,
    height: "fit-content",
    display: "flex",
    flexWrap: "wrap",
    width:"70%"
  },
  gridboxTime: {
    backgroundColor: "#ffff",
    m: 2,
    py: 4,
    px: 2,
    // mr: { xs: 3, sm: 3, md: 3, lg: 0 },
    borderRadius: "20px",
    // display: "flex",
    // justifyContent: "space-between",
    // alignItems: "center"


  },
  weakGrid: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 1

  },

  formControlLabel: {
    display: "block",
    mt:3
  },
  greyLine: {
    border: "1px solid #DEDEDE",
    width: "75%",
  },
  edit: {
    backgroundColor: "#A3E1FB",
    borderRadius: "8px",
    mx: 1,
    display: "flex",
    alignItems: "center",
    width: "27px",
    height: "27px",
    justifyContent: "center",

  },
  delete: {
    backgroundColor: color.lightRed,
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    width: "27px",
    height: "27px",
    justifyContent: "center",

  },

  gridboxs: {
    backgroundColor: "#ffff",
    mt: 0,
    mx: 2,
    mb: 2,
    py: 4,
    // mr: { xs: 3, sm: 3, md: 3, lg: 0 },
    borderRadius: "20px",
    height: "fit-content",

  },

  itemSection: {
    display: "flex",
    mx: 2,
    alignItems: "center",
    width: "100%",

  },
  gridText: {
    fontSize: "18px",
    fontWeight: "600"
  },
  bioBox: {
    px: 3,
    pt: 1,
  },
  content: {
    mt: 2,
    ml: 2,
    display: "flex",
    flexDirection: "row",
    // justifyContent:"space-Between"
  },
  switchSection: {
    display: "flex",
    alignItems: "center",
    mb: 1,
  },
  mainBoxes: {
    pr: 2,
    display: "flex",
    justifyContent: "end",
    my: 2

  },
  jobButtons: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#28AA4A",
    fontSize: "14px",
    fontWeight: "500",
    ml: 3,
    px: 4,
  },
  mainContainer: {
    // justifyContent: "end",
    // pr:{xs:1, md:1}
  },
  dropdown: {
    "& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "8.5px 14px",
    },
    // width:{ xs: "25em", md: "35em" },
    width: "100%",
    fontSize: "14px",
    fontWeight: "400",
    mt: 1,
  },
  typeGrid: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    px: "15px",
    mt: 2
  },
  popupBox: {
    width: "100%",
  },
  tableContainer: {
    backgroundColor: "#ffff",
    m: 2,
    borderRadius: "20px",
    p: 2,
  },
  tableWrapper: {
    boxShadow: "none",
  },
  tableHead: {
    color: "#000000",
    fontWeight: "600",
    fontSize: "14px",
    whiteSpace: "nowrap",
  },
  tableCell: {
    width: "25%",
    padding: "8px",
    "&:first-of-type": {
      width: "30%",
    },
    "&:last-of-type": {
      width: "10%",
    },
  },
  tableInput: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      height: "40px",
      minHeight: "40px",
      maxHeight: "40px",
    },
    "& .MuiInputBase-input": {
      padding: "8.5px 14px",
      height: "40px",
      minHeight: "40px",
      maxHeight: "40px",
      boxSizing: "border-box",
    },
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "8.5px 14px",
      height: "40px",
      minHeight: "40px",
      maxHeight: "40px",
      boxSizing: "border-box",
    },
  },
  tableSelect: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      height: "40px",
      minHeight: "40px",
      maxHeight: "40px",
    },
    "& .MuiInputBase-input": {
      padding: "8.5px 14px",
      height: "40px",
      minHeight: "40px",
      maxHeight: "40px",
      boxSizing: "border-box",
    },
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "8.5px 14px",
      height: "40px",
      minHeight: "40px",
      maxHeight: "40px",
      boxSizing: "border-box",
    },
    "& .MuiSelect-select": {
      height: "40px",
      minHeight: "40px",
      maxHeight: "40px",
      display: "flex",
      alignItems: "center",
      boxSizing: "border-box",
      padding: "8.5px 14px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      top: 0,
    },
  },
  deleteIconButton: {
    padding: "4px",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  deleteIcon: {
    color: "#ff0000",
    fontSize: "24px",
    cursor: "pointer",
    "&:hover": {
      color: "#cc0000",
    },
  },
  deleteButton: {
    backgroundColor: "#ff0000",
    color: "#ffffff",
    textTransform: "none",
    borderRadius: "8px",
    fontSize: "12px",
    fontWeight: "500",
    px: 2,
    "&:hover": {
      backgroundColor: "#cc0000",
    },
  },
  addButton: {
    borderRadius: "8px",
    textTransform: "none",
    backgroundColor: "#28AA4A",
    fontSize: "14px",
    fontWeight: "500",
    px: 3,
    "&:hover": {
      backgroundColor: "#28AA4A",
    },
  },
  saveAllButton: {
    borderRadius: "8px",
    textTransform: "none",
    backgroundColor: "#28AA4A",
    fontSize: "14px",
    fontWeight: "500",
    px: 3,
    "&:hover": {
      backgroundColor: "#28AA4A",
    },
  },
  modalLabel: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    mb: 0.5,
    mt: 1,
  },
  modalSelect: {
    width: "100%",
    borderRadius: "8px",
    height: "2.5em",
    mt: 1,
    mb: 1,
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "8.5px 14px",
    },
  },
  selectFY: {
    display: "flex",
    justifyContent: "center",
    my: "10px",
    height: "2.4em",
    fontSize: "14px",
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "5.5px 14px",
    },
    "& .MuiOutlinedInput-root": {
      padding: "0",
      height: "40px"
    },
    width: "300px",
  },
};

export default style;